import { all, takeEvery, put } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import queryString from 'query-string';

import {
  xcriticalFormError,
  xcriticalFormPropertyChange,
} from '@xcritical/forms';

import { registryActions } from '@crm-framework/registry';

import { checkTokenRequestAction } from './actions';
import { apiPostAuthToken } from './api';
import { TOKEN_FORM, TOOLS_REGISTERS } from './consts';

export function* watchApp() {
  yield takeEvery(checkTokenRequestAction.type, handleCheckToken);
}

function* handleCheckToken() {
  const { token } = queryString.parse(window.location.search);

  if (!token || Array.isArray(token)) {
    yield put(registryActions.set(TOOLS_REGISTERS.token, null));
    yield put(registryActions.set(TOOLS_REGISTERS.isReady, true));

    return;
  }

  yield put(xcriticalFormPropertyChange(TOKEN_FORM, 'token', token));

  try {
    yield call(apiPostAuthToken, { token });
    yield put(registryActions.set(TOOLS_REGISTERS.token, token));
  } catch (e) {
    console.error(e.status);

    if (e.status && e.status < 500) {
      yield put(xcriticalFormError(TOKEN_FORM, { token: 'Token is invalid.' }));
      yield put(registryActions.set(TOOLS_REGISTERS.token, null));

      return;
    }

    yield put(registryActions.set(TOOLS_REGISTERS.isUnavailable, true));
  } finally {
    yield put(registryActions.set(TOOLS_REGISTERS.isReady, true));
  }
}

export function* watchAppSagas() {
  yield all([watchApp].map((saga: any) => saga()));
}
